<template>
    <bs5-base-button variant="danger" size="sm" :loading="loading">
        <i class="bi bi-trash"></i> Delete
    </bs5-base-button>
</template>
<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
    name: "DeleteButton",
    props: {
        loading: { type: Boolean, default: false },
    },
});
</script>